export function validateRegex(value, regex) {
	const regExpression = new RegExp(regex);

	if (typeof value !== 'string' || regExpression.test(value)) {
		return '';
	}

	return 'Invalid Input values Found. RegEx Validation Failed, refer Example !';
}

export function convertStringToArray(stringValue: string) {
	const stringArray: string[] = [];
	
	if (stringValue) {
		stringArray.push(...stringValue.split(','));
	}

	return stringArray;
}

export function convertStringListToOptions(optionsList:string[]) {
	return optionsList.map((option) => ({
		label:option,
		value:option,
	}));
}